module.exports = __webpack_public_path__ + "img/pink.81f30594.svg";